import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Visual indicator for real-time data
 * @param {boolean} isRealTime - Whether data is real-time or fallback
 */
const RealTimeIndicator = ({ isRealTime }) => {
  const { t } = useTranslation();

  return (
    <span className="ml-1">
      {isRealTime ? (
        <span className="inline-flex items-center">
          <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse mr-1"></span>
          <span className="text-xs text-green-400">{t('products.live')}</span>
        </span>
      ) : (
        <span className="inline-flex items-center">
          <span className="w-2 h-2 bg-yellow-400 rounded-full mr-1"></span>
          <span className="text-xs text-yellow-400">{t('products.cached')}</span>
        </span>
      )}
    </span>
  );
};

export default RealTimeIndicator;
